import axios from 'axios'

// state
export const state = {
}

// getters
export const getters = {
}
// mutations
export const mutations = {
}
// actions
export const actions = {
  // eslint-disable-next-line no-empty-pattern
  async updateMyProfile({}, params) {
    try {
      const response = await axios.post('profile/updateProfile', params)
      return response
    } catch (error) {
      console.error(error)
    }
  },
  async updateMyCampaign({ commit }, params) {
    try {
      const response = await axios.patch('profile/campaign', params)
      commit('auth/setUserCampaign', params, { root: true })
      return response
    } catch (error) {
      console.error(error)
    }
  },
}
